import React, {
    Component
} from 'react'
import { actionTypes } from '~/constants';
import _ from 'lodash';
import moment from 'moment-timezone';
import Icon from '@material-ui/core/Icon';
import EnhancedTable from '~/widgets/table-enhanced'
import ButtonProgress from '~/widgets/button-progress'
import LinkButton from '~/widgets/button-link'


var __MATCHES = []

export default class Container extends Component {
    constructor() {
        super()
        this.state = {
        }
    }

    render() {
        let report = this.props.reports.detail;
        // console.log(report);

        // console.log(this.state)

        let matches = this.props.reports.list.filter(r=>__MATCHES.includes(r._id));
        let candidates = this.props.reports.list.filter(r=>!__MATCHES.includes(r._id));

        const sharedTableProps = {
            className: 'table-no-box-shadow',
            order: 'desc',
            orderBy: 'distance',
            rowsPerPage: 10,
            rowClickHandler: null,
            columns: [
              {id: 'createdAt', label: 'Created'},
              {id: 'address', label: 'Address'},
              {id: 'latitude', label: 'GPS'},
              {id: 'distance', label: 'Distance'},
              {id: null, label: 'Actions'},
            ],
        }

        let tableMatches =  (
            <EnhancedTable
                {...sharedTableProps}
                data={matches.map(c=>({
                    ...c,
                    distance: _.round(Math.random() * 10, 2),
                }))}
                buildTableRow={report=>{
                    return (
                        <React.Fragment>
                            <EnhancedTable.Cell>
                                {moment(report.createdAt).format('MMM Do, YYYY h:mma')}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {report.address}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {report.latitude}, {report.longitude}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {report.distance} miles
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                <ButtonProgress
                                    onClick={e=>{
                                        console.log(`click! r=${report._id}`)
                                        _.remove(__MATCHES, r=>r===report._id)
                                        console.log(__MATCHES)
                                        this.forceUpdate()
                                    }}
                                    className={`button button-clear button-small`}
                                    spinning={false}
                                >
                                    Un-Match
                                </ButtonProgress>
                            </EnhancedTable.Cell>
                        </React.Fragment>
                    );
                }}
            />
        )

        let tableCandidates =  (
            <EnhancedTable
                {...sharedTableProps}
                data={candidates.map(c=>({
                    ...c,
                    distance: _.round(Math.random() * 10, 2),
                }))}
                buildTableRow={report=>{
                    return (
                        <React.Fragment>
                            <EnhancedTable.Cell>
                                {moment(report.createdAt).format('MMM Do, YYYY')}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {report.address}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {Number(report.latitude).toFixed(2)}, {Number(report.longitude).toFixed(2)}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {report.distance} miles
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                <ButtonProgress
                                    onClick={e=>{
                                        console.log(`click! r=${report._id}`)
                                        __MATCHES.push(report._id)
                                        console.log(__MATCHES)
                                        this.forceUpdate()
                                    }}
                                    className={`button button-clear button-small`}
                                    spinning={false}
                                >
                                    Match
                                </ButtonProgress>
                            </EnhancedTable.Cell>
                        </React.Fragment>
                    );
                }}
            />
        )

        return (
            <React.Fragment>
                <div style={{float: 'right', padding: '1rem'}}>
                    <LinkButton className={`button ${__MATCHES.length ? 'button-secondary' : 'button-gray button-disabled'}`}>
                        Send CSV/PDF to VCA
                    </LinkButton>
                </div>
                <div className="card-content">
                    <h2 className="detail-heading">
                        Matched Reports
                    </h2>
                </div>
                <div style={{clear: 'both'}}/>
                {matches.length ? tableMatches : (
                    <React.Fragment>
                        <div style={{padding: '1rem'}}>
                            There are no duplicate reports or government data linked to this report.
                            <br/>
                            <br/>
                        </div>
                    </React.Fragment>
                )}
                <div className="card-content">
                    <h2 className="detail-heading">
                        Possible Duplicates & Government Data
                    </h2>
                </div>
                {tableCandidates}
            </React.Fragment>
        )
    }
}
